export const ROBINHOOD_CHAIN_ID = 4663

export function isKibaRouterRobinhoodEnabled(): boolean {
  return process.env.REACT_APP_ENABLE_KIBA_ROUTER_ROBINHOOD === 'true'
}

export function isKibaRouterBuildEnabled(): boolean {
  return process.env.REACT_APP_ENABLE_KIBA_ROUTER_BUILD === 'true'
}
